import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthTokenState] = useState(() => localStorage.getItem('tab365_token') || null);
  const [userInfo, setUserInfo] = useState(null);

  const setAuthToken = (token) => {
    if (token) {
      localStorage.setItem('tab365_token', token);
    } else {
      localStorage.removeItem('tab365_token');
    }
    setAuthTokenState(token);
  };

  const logout = () => {
    setAuthToken(null);
    setUserInfo(null);
  };

  useEffect(() => {
    if (authToken) {
      fetch('/api/v1/user/info', {
        headers: { 'Authorization': `Bearer ${authToken}` }
      })
      .then(res => res.json())
      .then(res => {
        if (res.code === 200 && res.data) {
          setUserInfo(res.data);
        } else {
          logout();
        }
      })
      .catch(err => {
        console.error('Failed to fetch user info', err);
      });
    } else {
      setUserInfo(null);
    }
  }, [authToken]);

  return (
    <AuthContext.Provider value={{ authToken, setAuthToken, userInfo, setUserInfo, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
